/**
 * Arrows for the review wall.
 *
 * The track is a scroll-snap row, so swiping already works everywhere without
 * JS. This only adds the buttons: it scrolls by one card, hides them when every
 * card already fits, and disables the one you cannot travel any further towards.
 */
(function () {
  var SELECTOR = '[data-review-wall]';

  function setup(wall) {
    if (wall.reviewWallReady) return;
    wall.reviewWallReady = true;

    var track = wall.querySelector('[data-review-wall-track]');
    var prev = wall.querySelector('[data-review-wall-prev]');
    var next = wall.querySelector('[data-review-wall-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.review-wall__card');
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var overflowing = track.scrollWidth - track.clientWidth > 2;
      wall.classList.toggle('review-wall--static', !overflowing);
      if (!prev || !next) return;

      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
